import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { login } from "../api/auth";
import { toast, ToastContainer, Zoom } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css"
import logo from '../img/logo/hyundaimobis_CI.png'
import store from '../redux/store';
import { setToken } from '../redux/slices/userSlice';
import Spinner from '../component/Spinner';

import { UnauthenticatedTemplate } from "@azure/msal-react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from '../authConfig';

function Login() {

  const { instance, accounts, inProgress } = useMsal();
  const activeAccount = instance.getActiveAccount();

  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) return;

    if (activeAccount) {
      const request = {
        ...loginRequest,
        account: accounts[0]
      };

      setIsLoading(true);
      instance.acquireTokenSilent(request).then(async (response) => {
        const msalToken = response.idToken;

        try {
          const result = await login(msalToken);
          store.dispatch(
            setToken({ token: result.token })
          );

          if (location.pathname === '/mes') {
            navigate("/mes/module");
          } else if (location.pathname === '/mesga') {
            navigate("/mesga/main")
          } else if (location.pathname === '/bsa1') {
            navigate("/bsa1/production");
          } else {
            navigate("/mes/module");
          }
        } catch (err) {
          console.error("[LOGIN ERROR]", err);
          toast.error("Login failed. Please try again.");
          setIsLoading(false);
        }
      }).catch(async (error) => {
        console.error("[ERROR] acquireTokenSilent:", error);
        setIsLoading(false);

        // Clear stale MSAL cache and redirect to login
        // This fixes Safari PWA (home screen bookmark) where the Sign In button
        // stays hidden because MSAL still has a cached activeAccount
        try {
          await instance.clearCache();
        } catch (clearError) {
          console.error("[ERROR] clearCache:", clearError);
        }

        store.dispatch(setToken({ token: "" }));
        instance.loginRedirect({
          ...loginRequest,
          prompt: "select_account",
        }).catch(redirectError => {
          console.error("[REDIRECT ERROR]", redirectError);
          toast.error("Authentication expired. Please sign in again.");
        });
      });
    }
  }, [activeAccount, inProgress]);

  const handleRedirect = () => {
    if (inProgress !== InteractionStatus.None) return;

    store.dispatch(
      setToken({ token: "" })
    );
    instance.loginRedirect({
      ...loginRequest,
      prompt: "select_account",
    }).catch(error => {
      console.error("[REDIRECT ERROR]", error);
      toast.error("Login redirect failed. Please try again.");
    });
  }


  return (
    <>
      <Spinner isShow={isLoading} />
      <ToastContainer draggable={false} transition={Zoom} autoClose={3000} style={{ width: "100%", textAlign: "center", fontSize: "100%" }} hideProgressBar />
      <UnauthenticatedTemplate>
        <div className="min-h-[calc(100vh)] flex flex-col items-center justify-center login-bg" >
          <div className="flex flex-col bg-white shadow-md px-4 sm:px-6 md:px-8 lg:px-10 py-8 rounded-md w-full max-w-md">
            <img src={logo} alt="Logo" />
            <div className="mt-10 mb-1 text-lg text-center">
              {location.pathname === '/mes' ? 'Alabama' :
                location.pathname === '/mesga' ? 'Georgia' : 'MNAe BSA1'}
            </div>
            <div className="relative h-px bg-gray-300" />
            <div className="mt-5">
              <div className="flex w-full">
                <button type="button"
                  className="flex items-center justify-center focus:outline-none text-white text-sm sm:text-base bg-blue-600 hover:bg-blue-700 rounded py-2 w-full transition duration-150 ease-in" onClick={handleRedirect}>
                  <span className="mr-2 uppercase">Sign In</span>
                  <span>
                    <svg className="h-6 w-6" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                      <path d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </UnauthenticatedTemplate>
    </>
  )
}

export default Login;
